

<template>
  <div>
    <h2>Overview of the first page of your appeal</h2>

    <div class="centered-child" style="margin: 32px 0px">

      <div style="display: block">
        <canvas v-show="pageRendered" id="pdfcanvas" style="border:1px solid #ddd"></canvas>
      </div>
      <div v-if="!pageRendered" style="max-width: 300px; border: 1px solid #ddd; border-radius: 2px; padding: 16px 32px; text-align: center; margin: 16px"> 
        Please wait, we are making the overview of your appeal.
        <br>
        <i class="fa fa-gear fa-spin" style="font-size:32px; margin-top: 16px; color: #888"></i>
      </div>
    </div>

    <div>
      <p>
      The document represents <u>a draft</u> of your appeal.
      Your <u> final </u> appeal will be sent to the administration once the file is completely done.
      </p>
    </div>
    <div class="centered-child" style="margin-top: 48px">
      <md-button class="md-raised md-primary large-button" @click="onContinue()">Continue</md-button>
    </div>

  </div>
</template>



<script>

import ServiceAccess from '../service/ServiceAccess'
import PDFJS from 'pdfjs-dist'

export default {

  data: function () {
    return {
      pdfDoc: null,
      pageNum: 1,
      pageRendering: false,
      pageRendered: false,
      pageNumPending: null,
      scale: 2,
      canvas: null,
      ctx: null
    }
  },

  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-preview-display')

  },

  mounted: function () {
    this.canvas = document.getElementById('pdfcanvas')
    this.ctx = this.canvas.getContext('2d')
    let url = ServiceAccess.instance.previewURL(this.$route.params.sessionId)
    let that = this

    PDFJS.PDFJS.workerSrc = '/pdf.worker.js'
    PDFJS.getDocument(url).then(function (pdfDoc_) {
      that.pdfDoc = pdfDoc_
      // document.getElementById('page_count').textContent = pdfDoc.numPages;
      // Initial/first page rendering
      that.renderPage(that.pageNum)
    })

  },

  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      if (this.paymentDone) {
        this.$router.replace('/f/' + this.$route.params.sessionId + '/')
      } else {
        this.$router.back()
      }
    },


    renderPage: function (num) {
      this.pageRendering = true
      // Using promise to fetch the page
      let that = this
      this.pdfDoc.getPage(num).then(function (page) {
        let viewport = page.getViewport(that.scale)
        that.canvas.height = viewport.height
        that.canvas.width = viewport.width
        that.canvas.style.width = '100%'
        that.canvas.style.height = '100%'
        that.pageRendered = true

       
    
        // Render PDF page into canvas context
        let renderContext = {
          canvasContext: that.ctx,
          viewport: viewport
        }
        let renderTask = page.render(renderContext)

        // Wait for rendering to finish
        renderTask.promise.then(function () {
          that.pageRendering = false
          let ctx = that.ctx
          ctx.globalAlpha = 0.4
          ctx.font = '128px sans-serif'
          ctx.fillStyle = 'black'
          var metrics = ctx.measureText('SPECIMEN')
          var width = metrics.width
          // var height = 64
          ctx.translate(that.canvas.width / 2 - width / 4, that.canvas.height / 2 + width / 3)
          ctx.rotate(-45 * Math.PI / 180)
          ctx.fillText('SPECIMEN', 0, 0)
          
        })

      })
    },



    onContinue: function () {
      this.$router.push('/f/' + this.$route.params.sessionId + '/payment/' + this.$route.params.cart)  

    }


  }
}
</script>


// WEBPACK FOOTER //
// CheckoutPreview.vue?6b3f45d0